import { all, call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import sagaListen from 'utils/sagaListen';
import { httpRequest } from 'utils/http';
import queryString from 'query-string';
import { transformPropsDeep } from 'containers/App/utils';
import { makeSelectCurrentRoute } from 'containers/App/selectors';
import {
  createSurveyModel,
  createDistributedSurveyModel,
  createPeeqSurveyModel,
} from 'containers/CreateSurveyModal/model';

import { getSurveyStoreParams } from 'containers/Survey/utils';
import { storeSurvey as storeSurveyModel } from 'containers/Survey/model';
import {
  SURVEY_TYPE_DISTRIBUTION_LINK,
  SURVEY_TYPE_PEEQ,
  SURVEY_TYPE_THIRD_PARTY,
} from 'containers/Survey/constants';

import {
  fetchTemplatePreviewSuccess,
  fetchTemplatePreviewError,
  createFromTemplateSuccess,
  createFromTemplateError,
} from './actions';
import { FETCH_TEMPLATE_PREVIEW, CREATE_FROM_TEMPLATE } from './constants';
import { fetchTemplatePreview } from './model';

export function* fetchTemplatePreviewSaga({ templateId }) {
  try {
    const response = yield call(httpRequest, fetchTemplatePreview, {
      excludedStatuses: [],
      params: { templateId },
    });

    yield put(fetchTemplatePreviewSuccess(response));
  } catch (error) {
    yield put(fetchTemplatePreviewError(error));
  } finally {
    yield put({ type: `${FETCH_TEMPLATE_PREVIEW}_FINISHED` });
  }
}

export function* createFromTemplateSaga({
  surveyName,
  surveyType,
  templateId,
  storeObject,
  defaultRecurrence,
  selectedCountry,
  totalCompletes,
  peeqCategoryType,
}) {
  try {
    // Create the survey
    let surveyCreateRequest = createSurveyModel;

    if (surveyType === SURVEY_TYPE_DISTRIBUTION_LINK) {
      surveyCreateRequest = createDistributedSurveyModel;
    }
    if (surveyType === SURVEY_TYPE_PEEQ) {
      surveyCreateRequest = createPeeqSurveyModel;
    }

    const route = yield select(makeSelectCurrentRoute);
    const urlParams = queryString.parse(route.search);
    let { folderId } = urlParams;
    if (folderId) {
      folderId = parseInt(folderId, 10);
    }

    const { id: surveyId } = yield call(httpRequest, surveyCreateRequest, {
      params: {
        name: surveyName,
        folderId,
        templateId,
        defaultRecurrence,
        selectedCountry,
        totalCompletes,
        categoryType: surveyType === SURVEY_TYPE_PEEQ ? peeqCategoryType : null,
      },
    });
    // done creating the survey

    // // Send the survey upsert
    const { targetingData, questionnaireData, isDistributionLink, isPeeq } =
      transformPropsDeep(storeObject, {
        surveyId,
      });

    const { params } = getSurveyStoreParams({
      targetingData,
      questionnaireData,
      surveyId,
      isDistributionLink,
      isPeeq,
    });

    yield call(httpRequest, storeSurveyModel, {
      excludedStatuses: [404],
      params,
    });

    yield put(createFromTemplateSuccess());
    if (surveyType === SURVEY_TYPE_THIRD_PARTY) {
      yield put(push(`/survey/targeting/${surveyId}`));
    } else {
      yield put(push(`/survey/questionnaire/${surveyId}`));
    }
  } catch (error) {
    yield put(createFromTemplateError(error));
  } finally {
    yield put({ type: `${CREATE_FROM_TEMPLATE}_FINISHED` });
  }
}

export default function* templatePreviewPageSaga() {
  yield all([
    call(sagaListen, FETCH_TEMPLATE_PREVIEW, fetchTemplatePreviewSaga),
    call(sagaListen, CREATE_FROM_TEMPLATE, createFromTemplateSaga),
  ]);
}
